export default __webpack_public_path__ + "static/media/mapicon.a06b1d4d.png";